import { Sparkles, Settings, Calendar } from "lucide-react";
import cleaningTeam from "../assets/image1.png";

const featureColors = ["#0d9488", "#f59e0b", "#ef4444"]; // Teal, Amber, Red

const features = [
  { icon: <Sparkles size={48} />, title: "Reliable Through Experience" },
  { icon: <Settings size={48} />, title: "Customizable Services" },
  { icon: <Calendar size={48} />, title: "Booking Online Appointment" },
];

const WhyChooseUs = () => {
  return (
    <section className="why-choose-us-section">
      <div className="container-fluid p-0">
        <div className="row g-0 align-items-center">
          {/* Left Side - Image */}
          <div className="col-md-6">
            <div
              className="left-image h-100"
              style={{
                backgroundImage: `url(${cleaningTeam})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                minHeight: "500px",
              }}
            ></div>
          </div>

          {/* Right Side - Content Card */}
          <div className="col-md-6 bg-dark text-white">
            <div className="card border-0 shadow-sm p-4 p-md-5 bg-transparent text-white">
              {/* Heading */}
              <div className="mb-4">
                <h6 className="text-info fw-semibold position-relative d-inline-block mb-3">
                  Why Choose Us
                  <span
                    className="position-absolute"
                    style={{
                      bottom: 0,
                      right: 0,
                      width: "50px",
                      height: "3px",
                      backgroundColor: "#9013FE",
                      
                    }}
                  ></span>
                </h6>
                <h2 className="fw-bold display-6">
                  Expert House Cleaning Service You Can Trust.
                </h2>
              </div>

              {/* Feature Cards */}
              <div className="row g-3 mt-4">
                {features.map((feature, idx) => (
                  <div className="col-12 col-sm-4" key={idx}>
                    <div
                      className="card border-0 p-3 text-center h-100 shadow-sm hover-shadow"
                      style={{
                        backgroundColor: featureColors[idx],
                        color: "#fff",
                        borderRadius: "12px",
                        transition: "transform 0.3s",
                      }}
                      onMouseEnter={e => e.currentTarget.style.transform = "scale(1.05)"}
                      onMouseLeave={e => e.currentTarget.style.transform = "scale(1)"}
                    >
                      <div className="mb-3 d-flex justify-content-center">
                        {feature.icon}
                      </div>
                      <h5 className="fw-bold">{feature.title}</h5>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
